module.exports = __webpack_public_path__ + "static/img/2.22851b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Bukanga-Lonzo/2.jpg
// module id = v9Qa
// module chunks = 0